import * as z from "zod";

export const verifyMerchantEmail = {
  name: "verifyMerchantEmail" as const,
  input: z.object({ email: z.string().email() }),
  output: z.object({
    dkimVerified: z.boolean(),
    returnPathVerified: z.boolean(),
  }),
};
